/**
 * The kind of destination a short code points at.
 *
 * `OFFER` → `targetId` is an offer UUID; the public redirect sends the visitor
 * to `/offers/{targetId}`. `URL` → `targetUrl` is an absolute URL the redirect
 * sends the visitor to directly. Exactly one of `targetId`/`targetUrl` is set
 * per type (enforced by a DB CHECK).
 */
export enum ShortUrlTargetType {
	OFFER = 'offer',
	URL = 'url',
}

/**
 * A short link: a GLOBALLY-unique code mapping to a generic target.
 *
 * The code is tenant-independent (a public visitor supplies no tenant) and is a
 * permanent pointer — it does NOT expire or get revoked (whether the *offer* is
 * still available is an offer-domain concern rendered at `/offers/{id}`, not a
 * property of the code). `tenantId` is carried for attribution/analytics only —
 * never for uniqueness or resolution (TO-281).
 */
export interface IShortUrl {
	/** Surrogate PK — resolved by the authenticated back-office endpoint. */
	shortUrlId: string
	/** Globally-unique public lookup key — resolved by the public `/s/{code}`. */
	code: string
	targetType: ShortUrlTargetType
	/** Set when `targetType === OFFER`. */
	targetId?: string
	/** Set when `targetType === URL`. */
	targetUrl?: string
	/** Owning tenant — attribution only. */
	tenantId: string
	createdAt: Date
}
